import { readTodoItem } from '@erikdakoda/todo/ai-tools/readTodoItem';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(readTodoItem);
